import React from 'react';
import logo from '../assets/logo192.png'; // Asegúrate que la ruta al logo sea correcta
import '../styles/LoadingScreen.css'; // Importamos los nuevos estilos

const LoadingScreen = ({ message = 'Cargando Lignums Group...' }) => {
    return (
        <div className="loading-screen-container">
            <div className="loading-content">
                <img src={logo} alt="Lignums Group Logo" className="loading-logo" />
                <p className="loading-text">{message}</p>
            </div>
        </div>
    );
};

export default LoadingScreen;